export const UPLOAD_AND_PLAY_EXTENSIONS = ['trm'];
export const ORDER_DETAILS_EXTENSIONS = [
    'bmp',
    'doc',
    'docx',
    'email',
    'eml',
    'emlx',
    'gif',
    'jpeg',
    'jpg',
    'msg',
    'odp',
    'ods',
    'odt',
    'pdf',
    'png',
    'ppt',
    'pptx',
    'rtf',
    'svg',
    'txt',
    'xls',
    'xlsx',
];
export const TRANSCRIBER_EXTENSIONS = [...ORDER_DETAILS_EXTENSIONS, 'zip', '7z'];
export const LOGO_EXTENSIONS = ['png'];
// Note: Currently transcriber extensions cover all supported extensions, if this assumption changes please update this to cover all extensions
export const ALL_SUPPORTED_EXTENSIONS = TRANSCRIBER_EXTENSIONS;
// File types that should have no discernible mime type, generally text formats
export const NO_MIME_TYPE_EXTENSIONS = ['email', 'eml', 'emlx', 'msg', 'txt', 'svg'];
// Images can switch extension and most image viewing programs handle it fine, so blocking them would confuse users
// We are adding an explicit exception where any 'image/*' mime-type can overlap
export const IMAGE_FILE_EXTENSIONS = ['bmp', 'gif', 'jpeg', 'jpg', 'png'];
export const IMAGE_MIME_TYPE_PREFIX = 'image/';
export function getFileExtension(filename) {
    var _a;
    const split = (_a = filename === null || filename === void 0 ? void 0 : filename.toLowerCase()) === null || _a === void 0 ? void 0 : _a.split('.');
    if (!split || split.length < 2 || !split[split.length - 1]) {
        return undefined;
    }
    return split[split.length - 1].trim();
}
